class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    const overlay = this.querySelector("#MenuDrawer-Overlay");
    if (overlay) {
      overlay.addEventListener("click", this.close.bind(this));
    }
  }

  close() {}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.header = document.querySelector(".section-header");
    this.borderOffset = this.closest(".header-wrapper")?.classList.contains(
      "header-wrapper--border-bottom"
    )
      ? 1
      : 0;

    // Ne cibler que le bouton X du header du drawer (sinon on attrape aussi les boutons internes)
    const closeButton = this.querySelector(
      ".menu-drawer__header .menu-drawer__close-button"
    );
    if (closeButton) {
      closeButton.addEventListener("click", () => this.close());
    }

    this.setupBurgerMenu();
    this.submenusInitialized = false; // Flag pour éviter les duplications
  }

  setupSubmenuToggles() {
    // Ne pas réinitialiser si déjà fait
    if (this.submenusInitialized) {
      return;
    }

    // Gérer les data-default-open avant d'initialiser les accordéons
    const accordionButtons = this.querySelectorAll(
      ".menu-drawer__accordion > button.menu-drawer__menu-item"
    );

    accordionButtons.forEach((button) => {
      const accordion = button.closest(".menu-drawer__accordion");
      const defaultExpanded = accordion?.dataset.defaultOpen === "true";
      
      if (defaultExpanded) {
        button.setAttribute("aria-expanded", "true");
      } else if (!button.hasAttribute("aria-expanded")) {
        button.setAttribute("aria-expanded", "false");
      }
    });

    // Utiliser le système centralisé d'accordéons
    if (window.initAccordion) {
      window.initAccordion(
        ".menu-drawer__accordion > button.menu-drawer__menu-item",
        { context: this }
      );
    }

    this.submenusInitialized = true;
  }

  setupBurgerMenu() {
    const burgerButton = document.querySelector(".header__icon--menu");
    if (burgerButton) {
      burgerButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.open();
      });
    }
  }

  open() {
    if (this.header) {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
      this.header.classList.add("menu-open");
    }

    setTimeout(() => {
      this.classList.add("active");
    });

    // Bloque le scroll directement
    document.body.style.overflow = "hidden";

    // Initialiser les animations des sous-menus (une seule fois grâce au flag)
    this.setupSubmenuToggles();
  }

  close() {
    this.classList.add("closing");
    this.classList.remove("active");

    // Réactive le scroll
    document.body.style.overflow = "";

    if (this.header) {
      this.header.classList.remove("menu-open");
    }

    setTimeout(() => {
      this.classList.remove("closing");
    }, 400);
  }
}

customElements.define("header-drawer", HeaderDrawer);
